import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import i18n from 'i18next';
import '@/utils/jquery-i18next';
import jQuery from 'jquery';

window._ = _;
window.moment = moment;
window.numeral = numeral;

// i18next is still used from window in html templates
window.i18next = i18n;

// jQuery is still used in `store/page/host-page-with-embed-script.html` and `store/page/host-page-with-inlined-bootstrap-script.html`
// and custom scripts
if (!window.jQuery) {
    window.jQuery = jQuery;
    window.$ = jQuery;
}
